import React, { useEffect } from "react";
import "./Overlay.css";
import { Link } from "react-router-dom";
function Overlay({ overlay }) {
  return (
    <div className={overlay}>
      <div className="overlay__options">
        <Link to="/#scroll__banner">
          <h4 className="links">Home</h4>
        </Link>
        <Link to="/about">
          <h4 className="links">About us</h4>
        </Link>
        <a href="/#work">
          <h4 className="links">Work</h4>
        </a>
        <Link to="/articles">
          <h4 className="links">Articles</h4>
        </Link>
        <a href="/#contact">
          <h4 className="links">Contact</h4>
        </a>
      </div>
    </div>
  );
}

export default Overlay;
